






import { COMPANY_STATUS } from 'gl-ms-offers';

export default {
    props: {
        tag: {
            type: String,
            default: COMPANY_STATUS.PROGRESS,
        },
    },
};
